import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const addNewExpenseItemQuery = (data) => {
  return axios.post(apiurl?.addExpenseItem, data);
};

const addNewExpenseItem = () => {
  const queryClient = useQueryClient();
  return useMutation(addNewExpenseItemQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getexpenseitemlist');
    }
  });
};

export default addNewExpenseItem;
